module.exports = __webpack_public_path__ + "img/tree-05-f-leaves.744987de.png";